export default "__VITE_ASSET__720f55a4__"